import { render, staticRenderFns } from "./TabsAsImages.vue?vue&type=template&id=ad9a1d72&scoped=true&"
import script from "./TabsAsImages.vue?vue&type=script&lang=js&"
export * from "./TabsAsImages.vue?vue&type=script&lang=js&"
import style0 from "./TabsAsImages.vue?vue&type=style&index=0&id=ad9a1d72&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad9a1d72",
  null
  
)

export default component.exports